<template>
  <path
    d="M13 16.1202C16.37 15.7202 19.01 12.9302 19.16 9.4802C19.33 5.6102 16.14 2.2302 12.27 2.1702C8.35 2.1202 5.17 5.2702 5.17 9.1702C5.17 12.6402 7.69 15.5102 11 16.0602V20.0002H6C5.45 20.0002 5 20.4502 5 21.0002C5 21.5502 5.45 22.0002 6 22.0002H18C18.55 22.0002 19 21.5502 19 21.0002C19 20.4502 18.55 20.0002 18 20.0002H13V16.1202Z"
  />
</template>
